import React from "react"

import SelectMultiGenericNew from "../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
import FieldUser_MultiselectValueNotEmpty from "../../components/multiselect/value-not-empty";
import FieldUser_MultiselectPopoverOption from "../../components/multiselect/popover-option";
import {FieldAutomationTriggerFormProps} from "../../../../render/automation-trigger-form";

export default class FieldUser_AutomationTriggerForm extends React.Component<FieldAutomationTriggerFormProps> {

    onChangeFromValues    = (fromValues:any)    => {
        this.props.onChangeCallback({fromValues})
    }
    onChangeToValues      = (toValues:any)      => this.props.onChangeCallback({toValues})

    render() {

        return (
            <div className="flex-row-left-top">
                <div className="label">from</div>
                <SelectMultiGenericNew className                        = "selector w-180"
                                       options                          = {this.props.field.getAutomationOptions()}
                                       values                           = {this.props.config.fromValues || this.props.config.fromValue} // config.fromValue is for custom fields
                                       allValuesOptionLabel             = "Any"
                                       popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                       allValuesOption                  = {true}
                                       isSearchable                     = {true}
                                       valueComponent                   = {FieldUser_MultiselectValueNotEmpty}
                                       popoverOptionComponent           = {FieldUser_MultiselectPopoverOption}
                                       disabled                         = {this.props.config.disabled}
                                       onChange                         = {this.onChangeFromValues}/>

                <div className="label">to</div>
                <SelectMultiGenericNew className                        = "selector w-180"
                                       options                          = {this.props.field.getAutomationOptions()}
                                       values                           = {this.props.config.toValues || this.props.config.toValue} // config.toValue is for custom fields
                                       allValuesOptionLabel             = "Any"
                                       popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                       allValuesOption                  = {true}
                                       isSearchable                     = {true}
                                       valueComponent                   = {FieldUser_MultiselectValueNotEmpty}
                                       popoverOptionComponent           = {FieldUser_MultiselectPopoverOption}
                                       disabled                         = {this.props.config.disabled}
                                       onChange                         = {this.onChangeToValues}/>
            </div>
        )
    }
}
